module.exports = __webpack_public_path__ + "img/magento-banner_small@2x.a5d9ca5b.jpg";